<!-- Shared by AdminAppointmentsComponent and StaffAppointmentsComponent; `isAdminUser` gates the admin-only parts. -->
<div class="appointments-header">
  <div class="setting">
    <div>
      <div class="h7">Appointments</div>
      <p class="p5">Track and manage your appointments</p>
    </div>
    <div *ngIf="isAdminUser">
      <button class="btn btn-primary btn-medium" (click)="openScheduleAppointmentModal()">
        <img src="/assets/images/package/plus.svg" alt="" />
        Add Appointments
      </button>
    </div>
  </div>
</div>

<div class="appointments-cards-container">
  <app-appointments-cards
    [title]="'Today\'s Appointments'"
    [count]="todaysAppointmentsCount"
    [cardClass]="'card-1'"
    [image]="'assets/dashboard/a-1.png'"
  ></app-appointments-cards>
  <app-appointments-cards
    [title]="'Completed Appointments'"
    [count]="completedAppointmentsCount"
    [cardClass]="'card-2'"
    [image]="'assets/dashboard/a-2.png'"
  ></app-appointments-cards>
  <app-appointments-cards
    [title]="'Pending Appointments'"
    [count]="pendingAppointmentsCount"
    [cardClass]="'card-3'"
    [image]="'assets/dashboard/a-3.png'"
  ></app-appointments-cards>
</div>

<!-- Appointments Toolbar -->
<app-appointments-toolbar
  [selectedView]="currentView"
  [selectedLocation]="currentLocation"
  [activeFilters]="activeFilters"
  [isAdminUser]="isAdminUser"
  (searchChanged)="onSearchChanged($event)"
  (viewChanged)="onViewChanged($event)"
  (locationChanged)="onLocationChanged($event)"
  (filterClicked)="onFilterClicked()"
  (filtersApplied)="onFiltersApplied($event)"
  (locationSelectionFromModal)="onLocationSelectionFromModal($event)"
></app-appointments-toolbar>

<!-- Figma-style link navigation (non-tab) -->
<nav
  class="appointments-link-nav"
  aria-label="Appointments navigation"
  *ngIf="currentView === 'list'"
>
  <a
    *ngFor="let link of navLinks; trackBy: trackByIndex"
    href="javascript:void(0)"
    class="appointments-link"
    [class.active]="activeNav === link.value"
    (click)="onNavSelect(link.value)"
  >
    {{ link.label }}
  </a>
</nav>

<!-- Appointments View -->
<div class="appointments-view-section">
  <!-- Show table when list view is selected -->
  <div *ngIf="currentView === 'list'" class="appointments-table-section">
    <app-appointments-table
      #appointmentsTable
      [activeFilters]="activeFilters"
      [searchTerm]="searchTerm"
      [currentLocation]="currentLocation"
      [selectedLocationLabels]="currentLocationLabels"
      [activeNav]="activeNav"
      [showAddButton]="isAdminUser"
      [isAdminUser]="isAdminUser"
      (addNewAppointment)="openScheduleAppointmentModal()"
      (createAnotherAppointment)="openScheduleAppointmentModal()"
      (appointmentUpdated)="onAppointmentUpdated()"
    >
    </app-appointments-table>
  </div>

  <!-- Show calendar when calendar view is selected -->
  <div *ngIf="currentView === 'calendar'" class="appointments-calendar-section">
    <app-appointments-calendar
      #appointmentsCalendar
      [activeFilters]="activeFilters"
      [searchTerm]="searchTerm"
      [selectedLocation]="currentLocation"
      [selectedLocationLabels]="currentLocationLabels"
      [isAdminUser]="isAdminUser"
      (createAnotherAppointment)="openScheduleAppointmentModal()"
    >
    </app-appointments-calendar>
  </div>
</div>

<!-- Schedule Appointment Modal (admin only) -->
<app-schedule-appointment-modal
  *ngIf="isAdminUser"
  [isVisible]="showScheduleAppointmentModal"
  (close)="closeScheduleAppointmentModal()"
  (appointmentCreated)="onAppointmentCreated()"
>
</app-schedule-appointment-modal>
